<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Дата поиска с лок. реестром</div>
            <div class="dx-field-value">
                <dx-date-box :value="data.date_connect_loc_reestr" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import { DxDateBox } from 'devextreme-vue';

const data = inject('serverData');
</script>
